"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("services/page/common");
var singleSliding_1 = require("./singleSliding");
var rollOver_1 = require("./rollOver");
var banner_1 = require("pc/utils/banner");
var WithPrm_1 = require("components/WithPrm");
var CardBanner = (function (_super) {
    __extends(CardBanner, _super);
    function CardBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCard = function (interaction, elements, viewMore) {
            var _a = _this.props, moduleDetail = _a.moduleDetail, id = _a.id, tprm = _a.tprm;
            if (interaction === common_1.ModuleInteraction.SingleSliding) {
                return React.createElement(singleSliding_1.default, { moduleDetail: moduleDetail, id: id, tprm: tprm });
            }
            if (interaction === common_1.ModuleInteraction.RollOver) {
                return React.createElement(rollOver_1.default, { cardBanners: elements, viewMore: viewMore, id: id, tprm: tprm });
            }
            return null;
        };
        return _this;
    }
    CardBanner.prototype.render = function () {
        var _a = this.props, moduleDetail = _a.moduleDetail, addModuleMap = _a.addModuleMap, index = _a.index, commonProps = _a.commonProps;
        var interaction, elements, viewMore;
        if (moduleDetail) {
            interaction = moduleDetail.layout.interaction;
            elements = banner_1.transformCardBanner(moduleDetail.module.elements);
            viewMore = moduleDetail.header.link;
        }
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } }, this.renderCard(interaction, elements, viewMore)));
    };
    return CardBanner;
}(React.Component));
exports.default = WithPrm_1.default(CardBanner);
